<template>
  <div class="atom-doughtnut-chart_graph">
    <label v-if="title" class="graph__title">{{ title }}</label>
    <div class="graph__container">
      <label v-if="subTitle" class="graph__sub-title">{{ subTitle }}</label>
      <v-chart
        class="graph__echarts"
        autoresize
        :option="option"
        ref="bar"
        auto-resize
      />
    </div>
  </div>
</template>

<script>
import { use } from "echarts/core"

// import ECharts modules manually to reduce bundle size
import { CanvasRenderer } from "echarts/renderers"
import { PieChart } from "echarts/charts"
import {
  GridComponent,
  TooltipComponent,
  LegendComponent,
} from "echarts/components"
import VChart from "vue-echarts"

use([
  CanvasRenderer,
  PieChart,
  GridComponent,
  TooltipComponent,
  LegendComponent,
])

export default {
  name: "AtomDoughnutChart",
  components: { VChart },
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    subTitle: {
      type: String,
      required: false,
      default: "",
    },
    color: {
      type: String,
      required: false,
      default: "primary",
      // value = [ "primary", "danger", "success", "secndary", "warning"]
    },
    value: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: false,
      default: 100,
    },
  },
  data() {
    return {
      option: {},
    }
  },
  computed: {
    pieColor() {
      if (this.color == "primary") return "#7367F0"
      if (this.color == "danger") return "#EA5455"
      if (this.color == "success") return "#28C76F"
      if (this.color == "secondary") return "#82868B"
      if (this.color == "warning") return "#FF9F43"
      return this.color
    },
  },
  mounted() {
    this.initialEcharts()
  },
  methods: {
    initialEcharts() {
      this.option = {
        series: [
          {
            type: "pie",
            size: "100%",
            radius: ["40%", "60%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            labelLine: {
              show: false,
            },
            silent: true,
            data: [
              {
                name: "Total",
                value: 100,
                itemStyle: {
                  color: "#E9ECEF",
                },
              },
            ],
          },
          {
            type: "pie",
            radius: ["40%", "60%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            labelLine: {
              show: false,
            },
            silent: true,
            data: [
              {
                name: "Used",
                value: this.value,
                itemStyle: {
                  color: this.pieColor,
                  borderRadius: "50%",
                },
              },
              {
                name: "Free",
                value: this.max - this.value,
                itemStyle: {
                  color: "#E9ECEF",
                  borderRadius: "0",
                },
              },
            ],
          },
        ],
      }
    },
  },
}
</script>

<style lang="scss" scoped>
label {
  margin-bottom: 0;
}

.atom-doughtnut-chart_graph {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.graph__title {
  color: #5E5873;
  font-size: 14px;
  font-weight: 500;
}
.graph__sub-title {
  color: #6E6B7B;
  font-size: 14px;
}
.graph__container {
  display: flex;
  align-items: center;
} 
.graph__echarts {
  margin-left: 12px;
  width: 31px;
  height: 31px;
}
</style>
